import React, { useEffect, useMemo, useState } from 'react';
import { createStore, Provider } from 'jotai';
import { useSelector } from 'react-redux';
import { muteAiAlertNotificationsFlagSelector } from '@src/store/common/selectors';
import AlertRulesDrawer from './AlertRulesDrawer';

export const OPEN_ALERT_RULES_EVENT = 'open-alert-rules';

const AlertRulesPage = () => {
  const rulesEnabled = useSelector(muteAiAlertNotificationsFlagSelector);
  const [openDrawer, setOpenDrawer] = useState(false);

  const store = useMemo(() => createStore(), []);

  const handleCloseDrawer = () => setOpenDrawer(false);

  useEffect(() => {
    if (!rulesEnabled) return undefined;
    const handleOpenPage = () => setOpenDrawer(true);
    window.addEventListener(OPEN_ALERT_RULES_EVENT, handleOpenPage);
    return () => {
      window.removeEventListener(OPEN_ALERT_RULES_EVENT, handleOpenPage);
    };
  }, [rulesEnabled]);

  // Gated behind the `mute-ai-alert-notifications` flag (dimension/metric mute).
  // Per-product eligibility (e.g. `app-experience` for eco) is additionally
  // enforced by the server on every request.
  if (!rulesEnabled) return null;

  return (
    <div data-ifc-event={OPEN_ALERT_RULES_EVENT}>
      <Provider store={store}>
        {openDrawer ? (
          <AlertRulesDrawer isOpen={openDrawer} closeDrawer={handleCloseDrawer} />
        ) : null}
      </Provider>
    </div>
  );
};

export default AlertRulesPage;
